export const CALCULATION_PARAMS = {
    coastingRating: { icon: 'coasting', translation: 'coasting' },
    accelerationPedalRating: { icon: 'kickdown', translation: 'accelerationPedal' },
    brakingRating: { icon: 'brake', translation: 'braking' },
    cruiseControlRating: { icon: 'cruise-control', translation: 'cruiseControl' },
    overSpeedRating: { icon: 'speed', translation: 'overspeed' },
    harshAccelerationRating: { icon: 'exclamation-sign', translation: 'harshAcceleration' },
    harshBrakingRating: { icon: 'dangerousgoods', translation: 'harshBraking' },
    excessiveIdlingRating: { icon: 'hour-glass', translation: 'excessiveIdling' },
    recuperationRating: { icon: 'refresh', translation: 'recuperationRating' },
    electricAccelerationPedalRating: {
        icon: 'electric-acceleration',
        translation: 'electricAccelerationPedal',
    },
    electricCruiseControlRating: {
        icon: 'electric-cruise-control',
        translation: 'electricCruiseControl',
    },
    electricOverSpeedRating: { icon: 'electric-speed', translation: 'electricOverspeed' },
};

export const electricCalculationParams = {
    coastingRating: { icon: 'coasting', translation: 'coasting' },
    electricAccelerationPedalRating: {
        icon: 'electric-acceleration',
        translation: 'electricAccelerationPedal',
    },
    brakingRating: { icon: 'brake', translation: 'braking' },
    electricCruiseControlRating: {
        icon: 'electric-cruise-control',
        translation: 'electricCruiseControl',
    },
    electricOverSpeedRating: { icon: 'electric-speed', translation: 'electricOverspeed' },
    harshAccelerationRating: { icon: 'exclamation-sign', translation: 'harshAcceleration' },
    harshBrakingRating: { icon: 'dangerousgoods', translation: 'harshBraking' },
    excessiveIdlingRating: { icon: 'hour-glass', translation: 'excessiveIdling' },
    recuperationRating: { icon: 'refresh', translation: 'recuperationRating' },
};

export const shouldHideCalculationParam = (
    key: string,
    shouldShowHarshKPIs: boolean,
    shouldShowExcessiveKPIS: boolean,
) =>
    (!shouldShowHarshKPIs && ['harshAccelerationRating', 'harshBrakingRating'].includes(key)) ||
    (!shouldShowExcessiveKPIS && key === 'excessiveIdlingRating');
